<template>
  <div>
    <h1>品牌管理</h1>
    <div id="components-form-demo-advanced-search">
      <a-form layout="inline" class="ant-advanced-search-form">
        <a-row>
          <a-col :span="6">
            <a-form-item label="品牌名称">
              <a-input size="small" v-model="queryParam.query_name_like" placeholder="品牌名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="6 " :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="{} "
            >
              <a-button size="small" type="primary" @click="reloadTable">查询</a-button>
              <a-button style="margin-left: 8px" size="small" @click="queryParamRest">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <p></p>
    <div class="table-operations">
      <a-button size="small" type="primary" @click="goToAdd">添加</a-button>
      <p></p>
    </div>
    <a-table
      ref="table"
      bordered
      :columns="columns"
      rowKey="id"
      :dataSource="data"
      :pagination="pagination"
      :pageSizeOptions="pagination.pageSizeOptions"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a-button size="small" @click="goToUpdate(record.id)">修改</a-button>
        <a-divider type="vertical"/>
        <a-button size="small" type="danger" @click="deleteById(record.id)">删除</a-button>
      </span>
    </a-table>
  </div>
</template>
<script>
export default {
  name: "brandIndex",
  mounted() {},
  created() {
    this.reloadTable();
  },
  data() {
    return {
      queryParam: {},
      data: [], //渲染表格数据
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        current: 1,
        defaultCurrent: 1,
        pageSize: 10,
        defaultPageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `Total ${total} items`
      },
      loading: false,
      columns: [
        {
          title: "品牌名称",
          dataIndex: "name",
          queryname: "query-name-eq",
          key: "query-nickName-eq",
          width: "20%",
          sorter: true
        },
        {
          title: "排序",
          dataIndex: "sortNo",
          width: "20%",
          sorter: true
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.fetch(
        this.$http.initParams(pagination, filters, sorter, this.queryParam)
      );
    },
    fetch(params = {}) {
      this.loading = true;
      this.$http.get("/api/1.0/brand/page", params).then(res => {
        const data = res.data;
        this.data = data.records;
        const pagination = { ...this.pagination };
        pagination.total = data.total;
        pagination.pageSize = data.size;
        pagination.current = data.current;
        this.pagination = pagination;
      });
      this.loading = false;
    },
    onShowSizeChange: () => {
      this.pagination.pageSize = pageSize;
    },

    queryParamRest() {
      this.queryParam = {  };
      this.reloadTable();
    },
    reloadTable() {
      this.handleTableChange(this.pagination, null, null, this.queryParam);
    },
    deleteById: function(id) {
      this.$http.get("/api/1.0/brand/delete/" + id).then(res => {
        this.reloadTable();
      });
    },
    goToAdd() {
      this.$router.push({
        path: "/brand/add"
      });
    },
    goToUpdate(id) {
      this.$router.push({
        path: "/brand/update/" + id
      });
    },
  }
};
</script>

<style scoped>
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0px;
}
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-advanced-search-form {
  padding: 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
</style>